import React, { Component } from 'react';
import {
  Alert,
  Button,
  KeyboardAvoidingView,
  ScrollView,
  TextInput,
  View,
} from 'react-native';
import Styles from './styles';
import Config from './config';
import Hermes from './hermes';

export default class AddUserView extends Component {
  static navigationOptions = {
    title: 'Add User',
  };
  constructor() {
    super();
    this.state = {
      username: '',
      password: '',
      verify: '',
    };
    this._add = this._add.bind(this);
  }

  async _add(goBack) {
    const {username, password, verify} = this.state;
    try {
      await Hermes.fetch(`${Config.Scheme}://${Config.Domain}/users`, {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        },
        method: "POST",
        body: JSON.stringify({
          user: {
            username: username,
            password: password,
            verify: verify,
          },
        }),
      });

      Alert.alert(`Email sent to ${username}`)
      goBack();
    } catch(error) {
      Hermes.alert(error);
    }
  }

  render() {
    const add = () => this._add(this.props.navigation.goBack)
    return (
      <View style={Styles.container}>
        <KeyboardAvoidingView behavior={'height'} style={Styles.modal}>
          <ScrollView keyboardShouldPersistTaps='always'>
            <TextInput
              style={Styles.input}
              onChangeText={(text) => this.setState({username: text})}
              value={this.state.username}
              placeholder="Username (email)"
              autoCapitalize='none'
              returnKeyType='next'
              onSubmitEditing={() => this.textInputPassword.focus()}/>
            <TextInput
              style={Styles.input}
              onChangeText={(text) => this.setState({password: text})}
              value={this.state.password}
              placeholder="Password"
              autoCapitalize='none'
              secureTextEntry={true}
              returnKeyType='next'
              onSubmitEditing={() => this.textInputVerify.focus()}
              ref={(input) => this.textInputPassword = input}/>
            <TextInput
              style={Styles.input}
              onChangeText={(text) => this.setState({verify: text})}
              value={this.state.verify}
              placeholder="Verify Password"
              autoCapitalize='none'
              secureTextEntry={true}
              returnKeyType='done'
              onSubmitEditing={add}
              ref={(input) => this.textInputVerify = input}/>
            <View style={{padding: 10}}>
              <Button
                onPress={add}
                title="Done"
                color="#841584"
                accessibilityLabel="New user is created"/>
            </View>
            <View style={{height: 40}}></View>
          </ScrollView>
        </KeyboardAvoidingView>
      </View>
    );
  }
}
